import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { DistributorsService } from '../services/distributors.service';
import { MessageService } from 'primeng/components/common/messageservice';
import { Distributor } from '../../models/distributor';
import { Response } from '@angular/http';
import { environment } from '../../../environments/environment';
import { DistributorProduct } from '../../models/distributor-product';
import { BreadcrumbService } from '../../breadcrumb/breadcrumb.service';
import { DistributorProductsService } from '../services/distributor-products.service';
import { ConfirmationService, Confirmation } from 'primeng/components/common/api';
import { LoadingBarService } from '@ngx-loading-bar/core';
import {GroupRight} from '../../models/group-right';
import {GroupRightService} from '../../services/group-right.service';
import {ProductKind} from '../../models/product-kind';
import {ProductKindService} from '../../services/product-kind.service';

@Component({
	selector: 'app-distributor-product-detail',
	templateUrl: './distributor-product-detail.component.html'
})
export class DistributorProductDetailComponent implements OnInit
{
	public distributorProduct: DistributorProduct;
	public productKinds: ProductKind[];
	public isNew: boolean;

	public distributorId: number;
	public groupRight: GroupRight = null;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private messageService: MessageService,
		private confirmationService: ConfirmationService,
		private breadcrumbService: BreadcrumbService,
		private loadingBar: LoadingBarService,
		private distributorProductsService: DistributorProductsService,
		private groupRightService: GroupRightService,
		private productKindService: ProductKindService,
	)
	{
	}

    ngOnInit()
	{
		this.productKinds = this.route.snapshot.data['productKinds'].data;

		if (this.route.snapshot.data['groupRights'] instanceof Array) {
			this.groupRight = this.groupRightService.getGroupRightForModule('distributor', this.route.snapshot.data['groupRights'])
		}

		this.distributorId = this.route.snapshot.params['distributorId'];

		const productData: any = this.route.snapshot.data['distributorProduct'];

		if (productData instanceof Object && !(productData instanceof Response))
		{
			this.distributorProduct = productData;
			this.breadcrumbService.addBreadcrumbTranslation('Product Bewerken', this.distributorProduct.name);
			this.isNew = false;
		}
		else
		{
			this.distributorProduct = new DistributorProduct();
			this.distributorProduct.distributor = new Distributor();
			this.distributorProduct.distributor.id = this.distributorId;
			this.isNew = true;
		}
    }

    public goBack()
	{
		this.router.navigate(['/verspreiders/' + this.distributorId]);
	}

	public hasUserAccess(action: string)
	{
		return this.groupRight && this.groupRight[action];
	}

	public removeProduct()
	{
		this.loadingBar.start();

		this.distributorProductsService.removeDistributorProduct(this.distributorProduct.id)
			.then((data) =>
			{
				this.messageService.add({
					severity: 'success',
					summary: 'Product verwijderd',
					detail: 'Het product van de verspreider is verwijderd.'
				});

				this.router.navigate(['/verspreiders/' + this.distributorId]);

				this.loadingBar.complete();
			})
			.catch((data) =>
			{
				this.messageService.add({
					severity: 'error',
					summary: 'Product niet verwijderd',
					detail: 'Het product van de verspreider kon niet worden verwijderd.'
				});

				this.loadingBar.complete();
			});

	}

	public saveProduct()
	{
		this.loadingBar.start();

		let promise: Promise<DistributorProduct>;

		if (this.isNew)
		{
			promise = this.distributorProductsService.saveDistributorProduct(this.distributorProduct);

			promise.then((data) =>
			{
				if (data instanceof Response)
				{
					if (data.status === 422)
					{
						const shownMessages: Array<string> = [];
						const message: Object = data.json().message;

						Object.keys(message).forEach((fieldName) =>
						{
							message[fieldName].forEach((message) =>
							{
								if (shownMessages.indexOf(message) === -1)
								{
									shownMessages.push(message);

									this.messageService.add({
										severity: 'warning',
										summary: 'Validatiefout',
										detail: environment.validation.distributor_contract_area[message]
									});
								}
							});
						});

						this.loadingBar.complete();
					}
				}
				else
				{
					this.messageService.add({
						severity: 'success',
						summary: 'Product opgeslagen',
						detail: 'Het product is met succes opgeslagen.'
					});

					this.router.navigate(['/verspreiders/' + this.distributorId]);
					this.loadingBar.complete();
				}
			});
		}
		else
		{
			console.log("update");

			promise = this.distributorProductsService.updateDistributorProduct(this.distributorProduct);

			promise.then((data) =>
			{
				if (data instanceof Response)
				{
					if (data.status === 422)
					{
						const shownMessages: Array<string> = [];
						const message: Object = data.json().message;

						Object.keys(message).forEach((fieldName) =>
						{
							message[fieldName].forEach((message) =>
							{
								if (shownMessages.indexOf(message) === -1)
								{
									shownMessages.push(message);

									this.messageService.add({
										severity: 'warning',
										summary: 'Validatiefout',
										detail: environment.validation.distributor_contract_area[message]
									});
								}
							});
						});
					}
				}
				else
				{
					this.messageService.add({
						severity: 'success',
						summary: 'Product opgeslagen',
						detail: 'Het product is met succes opgeslagen.'
					});

					this.router.navigate(['/verspreiders/' + this.distributorId]);
				}
			});
		}
	}
}



// WEBPACK FOOTER //
// ./src/app/distributors/distributor-product-detail/distributor-product-detail.component.ts